module.exports = __webpack_public_path__ + "img/client21.7330bbaa.svg";